import * as React from 'react';

import { mountModal } from 'lib/modal';
import Glyph from 'components/Glyph';
import type { GlyphSize } from 'components/Glyph';
import Button, { ButtonSize } from 'components/ButtonDeprecated';
import PhoneCallModal, { isFixableDenialReason } from 'phoneCalls/components/PhoneCallModal';
import type { DenialReason } from 'phoneCalls/components/PhoneCallModal';
import PhoneCallDenialReasonTooltip from 'phoneCalls/components/PhoneCallDenialReasonTooltip';

type Props = {
  className?: string | null;
  calleeUuid: string;
  calleeName: string;
  inline?: boolean;
  size?: typeof ButtonSize[keyof typeof ButtonSize];
  denialReason?: DenialReason;
  glyphSize?: GlyphSize;
};

type State = {
  glyphFilled: boolean;
};

class PhoneCallButton extends React.Component<Props, State> {
  state: State = {
    glyphFilled: false,
  };

  static defaultProps = {
    glyphSize: 'medium',
    onMouseEnter: () => {},
  };

  showCallModal = () => {
    mountModal(<PhoneCallModal calleeUuid={this.props.calleeUuid} />, this);
  };

  toggleFill = () => {
    const { glyphFilled } = this.state;
    this.setState({
      glyphFilled: !glyphFilled,
    });
  };

  render() {
    const { denialReason, calleeName, glyphSize } = this.props;
    const { glyphFilled } = this.state;
    const buttonProps = {
      'aria-label': 'Call',
      eventElementName: 'call_user_button',
      size: this.props.size || ButtonSize.xxsmall,
      className: this.props.className,
      onClick: this.showCallModal,
      disabled: denialReason && !isFixableDenialReason(denialReason),
    };
    const color = denialReason ? 'graphite' : 'mascot';
    return (
      <PhoneCallDenialReasonTooltip denialReason={denialReason} calleeName={calleeName}>
        {this.props.inline ? (
          <div style={{ display: 'inline-block' }}>
            {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; level: "text"; 'aria-la... Remove this comment to see the full error message */}
            <Button {...buttonProps} level="text" aria-label="denial">
              <Glyph
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                onMouseOver={this.toggleFill}
                onMouseLeave={this.toggleFill}
                name={glyphFilled && !denialReason ? 'phone-filled' : 'phone'}
                color={color}
                solo
                size={glyphSize}
              />
            </Button>
          </div>
        ) : (
          <div>
            {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; color: "mascot"; level:... Remove this comment to see the full error message */}
            <Button
              {...buttonProps}
              color="mascot"
              level="secondary"
              aria-label="phone"
              size="xsmall"
            >
              <Glyph name="phone" solo size={glyphSize} />
            </Button>
          </div>
        )}
      </PhoneCallDenialReasonTooltip>
    );
  }
}

export default PhoneCallButton;
